import React, { Fragment, useState } from 'react';
import { PlanLink } from 'Features/Plans/PlanLink';
import { PlanDetailModal } from 'Features/Plans/PlanDetailModal';
import { SubmitButton } from 'Components/Fields/Buttons';
import { getSimplifiedPlanDisplayName } from 'Utils/Plans';
import './ChangePlan.css';

const PlanCTAButton = ({ plan, subscription, isDisabled }) => {
  const isPlanActive = plan.planId === subscription.activeSubscriptionId;
  const isUpcomingPlan =
    plan.planId === ((subscription.nextSubscription && subscription.nextSubscription.serviceID) || '');

  const renderPlanCta = () => {
    if (isUpcomingPlan) {
      return <SubmitButton className="selectPlanCta" text="Your Upcoming Plan" isDisabled />;
    }
    if (isPlanActive) {
      return <SubmitButton className="selectPlanCta" text="Your Current Plan" isDisabled />;
    }
    const planLinkClassName = isDisabled ? `selectPlanCta isDisabled` : 'selectPlanCta';
    return <PlanLink className={planLinkClassName} plan={plan} />;
  };

  return <div className="selectPlanCtaWrapper">{renderPlanCta()}</div>;
};
const PlanSummary = ({ planBenefits, toggleModal }) => {
  return (
    <div className="benefits">
      <ul className="benefitsList">
        {planBenefits.summary.map((benefit, index) => (
          <li className="benefitItem" key={index}>
            {benefit}
          </li>
        ))}
      </ul>
      {planBenefits.details.list.length > 0 && (
        <div className="benefitDetails" role="button" onClick={() => toggleModal(true)}>
          More details
        </div>
      )}
    </div>
  );
};
const PlanLimitedPromoBanner = ({ showBanner, planBenefits }) => {
  if (showBanner && planBenefits.limitedOffer) {
    return (
      <div className="planCardBanner">
        <img className="planCardBannerImg" src="/account/static/images/FN/limited-ribbon.png" alt="LIMITED TIME ONLY" />
      </div>
    );
  }
  return null;
};

export function ChangePlan({ plan, subscription, showBannerPlans, planBenefits = {}, disableCta = false }) {
  const isPlanActive = plan.planId === subscription.activeSubscriptionId;

  const [showModal, toggleModal] = useState(false);
  const price = plan.planPrice.toFixed(2);
  const frequency = plan.planFrequencyText;
  const simplifiedPlanName = getSimplifiedPlanDisplayName(plan);

  let pricingDisplay = `$${price}/${frequency}`;

  return (
    <Fragment>
      <div className="planCard">
        <div className="planCardInner">
          <div className="imageWrapper">
            {planBenefits.image && <img className="image" src={planBenefits.image} alt={simplifiedPlanName} />}
          </div>
          <div className="title">{simplifiedPlanName}</div>
          <div className="frequency">{pricingDisplay}</div>
          <PlanSummary planBenefits={planBenefits} toggleModal={toggleModal} />
          <PlanCTAButton plan={plan} subscription={subscription} isDisabled={disableCta} />
        </div>
        <PlanLimitedPromoBanner showBanner={showBannerPlans} planBenefits={planBenefits} />
      </div>

      <PlanDetailModal
        customClass="changePlans"
        show={showModal}
        isPlanActive={isPlanActive}
        planBenefits={planBenefits}
        plan={plan}
        onSelectPlan={() => toggleModal(false)}
        onClose={() => toggleModal(false)}
        disableCta={disableCta}
      />
    </Fragment>
  );
}
